/** Inertia + inertia_rails may send `errors` as `[]` or `{}` when empty—never assume `.filter` exists. */
export function inertiaMessageList(errors: unknown): string[] {
  if (!Array.isArray(errors)) {
    return []
  }
  return errors.filter((msg): msg is string => typeof msg === 'string' && msg.length > 0)
}
